// Mixlr Header =======================================

.mixlr-footer {
  align-items: center;
  display: flex;
  font-size: 1.2rem;
  flex: 0;
  justify-content: center;
  padding: var(--spacing__large);
  position: relative;
  width: 100%;
}